import { createSlice } from "@reduxjs/toolkit";


export const globalSlice = createSlice({
    name: "Global",
    initialState: {
        value: 'XYZ'
    },
    reducers:{
        globalAction: (state, value) => {
            state.value = value
        }
    }
})

export const {globalAction} = globalSlice.actions
export default globalSlice.reducer